"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFundsOriginTrads = void 0;
exports.EFundsOriginTrads = {
    disposal_real_estate_assets: "Cession d'actifs immobiliers",
    disposal_securities_assets: "Cession de valeurs mobilières",
    donation: "Donation",
    inheritance: "Succession",
    life_insurance_buyback: "Rachat d'assurance vie",
    loan: "Emprunt",
    professional_income: "Revenus professionnels",
    savings: "Epargne",
    other: "Autres: Précisez",
};
